/* AndroDeck theme */
(function () {
  'use strict';

  /* --- mobile nav --- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.getElementById('primary-nav');
    if (!nav) return;
    var open = nav.classList.toggle('open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* --- product gallery --- */
  var mainImg = document.getElementById('pdp-main-img');
  if (mainImg) {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      mainImg.src = thumb.getAttribute('data-full');
      mainImg.srcset = thumb.getAttribute('data-srcset') || '';
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      mainImg.removeAttribute('width');
      mainImg.removeAttribute('height');
      document.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  }

  /* --- sticky buy bar: show past the hero, then hide itself again --- */
  var bar = document.querySelector('[data-buybar]');
  if (!bar) return;

  var DISMISSED = 'androdeck:buybar-dismissed';
  var timer = null;
  var shown = false;
  var delay = parseInt(bar.getAttribute('data-autohide'), 10);
  if (isNaN(delay)) delay = 8;

  function dismissed() {
    try { return sessionStorage.getItem(DISMISSED) === '1'; } catch (err) { return false; }
  }
  function remember() {
    try { sessionStorage.setItem(DISMISSED, '1'); } catch (err) {}
  }

  function hide() {
    bar.classList.remove('is-visible');
    clearTimeout(timer);
  }

  function show() {
    if (shown || dismissed()) return;
    shown = true;
    bar.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    if (delay > 0) {
      timer = setTimeout(function () { hide(); }, delay * 1000);
    }
  }

  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-buybar-close]')) {
      hide();
      remember();
    }
  });

  var hero = document.querySelector('.hero');
  var trigger = hero ? hero.offsetHeight * 0.85 : 600;

  function onScroll() {
    if (window.scrollY > trigger) {
      show();
      window.removeEventListener('scroll', onScroll);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
